module.exports = __webpack_public_path__ + "img/cli_10.7c05d03b.png";